import { CardHeadingCancelled } from "./cardHeadingCancelled";
import { Text } from "@medoma/components/Text/Text";
import styles from "./groupCardCancelled.module.scss";
import { plural } from "@lingui/core/macro";
import type { IGroupableCategory } from "@medoma/models/activities";

type IGroupCardCancelled = {
  timeSpanText: string | null;
  occurrenceCount: number;
  category: IGroupableCategory;
};

export const GroupCardCancelled = ({
  timeSpanText,
  occurrenceCount,
  category,
}: IGroupCardCancelled) => {
  const activityCount = plural(occurrenceCount, {
    one: "# aktivitet",
    other: "# aktiviteter",
  });
  return (
    <>
      <CardHeadingCancelled category={category} />
      <Text element="span" size="small">
        {timeSpanText ? (
          <>
            {timeSpanText}
            <span className={styles.cancellationSeparator} aria-hidden="true" />
          </>
        ) : null}
        {activityCount}
      </Text>
    </>
  );
};
